import { useTranslations } from 'next-intl';
import { Title } from '../../shared/title';
import { Wrapper } from '../../shared/wrapper';
import { FC, memo, useEffect, useState } from 'react';
import LazyImage from '../LazyImage';
// import { styled } from '../../shared/styles';
import { styled } from '../../shared/styles';

let Description: FC<{ className?: string }> = ({ className }) => {
  const t = useTranslations();
  const [isScaledDown, setIsScaledDown] = useState(false);
  const [initialHeight, setInitialHeight] = useState<number | null>(null);

  useEffect(() => {
    const height = window.screen.height;
    setInitialHeight(height);

    const checkZoom = () => {
      const zoom = window.outerWidth / window.innerWidth;
      setIsScaledDown(zoom < 0.8);
    };

    checkZoom();

    window.addEventListener('resize', checkZoom);

    return () => {
      window.removeEventListener('resize', checkZoom);
    };
  }, []);

  return (
    <div className={className}>
      <article
        style={isScaledDown && initialHeight ? { height: `${initialHeight}px` } : { height: 'calc(100vh + 10px)' }}
        className={`description ${isScaledDown ? 'description_fixed-height' : ''}`}
      >
        <Wrapper className='description_container prescale'>
          <div className='description_eclipse' />
          <LazyImage className='description_left' src='/images/icons/landing/left_icon.svg' alt='left' />
          <LazyImage className='description_right' src='/images/icons/landing/right_icon.svg' alt='right' />
          <Title
            textClassName='desc_mw'
            textWidth={751}
            title={t('description.title')}
            text={
              <>
                {t('description.text_1')} <br />
                {t('description.text_2')} <br />
                {t('description.text_3')}
              </>
            }
          />
        </Wrapper>
      </article>
    </div>
  );
};

Description = styled(Description, {
  '& .description': {
    minHeight: 'calc(100vh + 10px)',
    padding: '120px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@to1920': {
      padding: '120px 0'
    },

    '@from2200': {
      padding: '120px 0'
    },

    '@from2400': {
      minHeight: '824px'
    },

    '@toMedium': {
      padding: '120px 0'
    },

    '@toTablet': {
      padding: '80px 0'
    }
  },

  '& .description_container': {
    width: '100%',
    position: 'relative'
  },

  '& .description_eclipse': {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%) scale(1.8)',
    // opacity: 0.6,

    width: '1268px' /* Ширина из Figma */,
    height: '1278px' /* Высота из Figma */,
    background: 'radial-gradient(circle, rgba(125, 64, 255, 0.6) 0%, rgba(0, 0, 0, 0) 100%)',
    opacity: 0.25,
    mixBlendMode: 'plus-lighter',
    filter: 'blur(150px)' /* Размытие для мягкости */,
    pointerEvents: 'none'
  },

  // '& .desc_mw': {
  //   maxWidth: '988px',
  //   '@toXl': {
  //     maxWidth: '751px'
  //   }
  // },

  '& .description_left': {
    position: 'absolute',
    left: '53px',
    top: '-68px',
    '@toDesktop': {
      left: '-36px',
      top: '-148px'
    },
    '@toTablet': {
      left: '-56px'
    }
  },

  '& .description_right': {
    position: 'absolute',
    bottom: '-220px',
    right: '-42px',
    '@toDesktop': {
      right: '-83px',
      bottom: '-269px'
    },

    '@toTablet': {
      right: '-103px',
      transform: 'scale(0.8)',
      bottom: '-200px'
    }
  }
});

export default memo(Description);
